import React, { Component, PropTypes } from 'react';
import getRoutes from 'routes';
import { connect } from 'react-redux';

import { getCurrentUserDetails } from 'actions/user';
import { routeCodes, subRouteCodes } from 'constants/routes';
import NotificationsCenter from 'containers/NotificationsCenter';
import { setNotificationCenterModalState, fetchNotificationsAsync } from 'actions/notifications';
import GlobalPriceModal from 'components/GlobalPriceModal';
import { getPriceEffectiveDate, isGlobalPriceEligible } from 'helpers/globalPriceHelper';
import {
  GP_PRICE_UPDATE_MODAL_HEADER,
  GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION1,
  GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION2,
  GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION3,
  GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION4,
  GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION5,
} from 'constants/globalPrice';
import moment from 'moment';
import { updateGlobalPrice, setGlobalPriceUpdateModalState, setAfterPriceOutdatedWarningState, setPriceOutdatedWarningState } from 'actions/globalPrice';
import { getCurrentUserBrand } from 'selectors/user-brands';
import PageLoadingWithText from 'components/PageLoading/PageLoadingWithText';
import { createEvent } from 'googleanalytics';
import { CATEGORIES, ACTIONS } from 'constants/googleAnalytics';
import { createAccessToken } from 'actions/gbp';
import { fetchContentstackAsync } from '../../actions/contentstack';

@connect(state => ({
  notifications: state.notifications,
  user: state.user.get('data'),
  syscoProducts: state.syscoProducts.get('data'),
  globalPrice: state.globalPrice,
  currentBrand: getCurrentUserBrand(state),
}))
class Root extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    notifications: PropTypes.object,
    dispatch: PropTypes.func,
    user: PropTypes.object,
    syscoProducts: PropTypes.object,
    globalPrice: PropTypes.object,
    currentBrand: PropTypes.object,
  }

  componentDidMount() {
    let accountId = null, googleGrantCode = null, isVettedToken = false;
    const dispatch = this.props.store.dispatch;

    const urlParams = new URLSearchParams(window.location.search);
    if (window.location.pathname === routeCodes.DASHBOARD) {

      // code param is sent when google login redirection 
      googleGrantCode = urlParams.get('code');

      // accountId is sent when SalesForce login
      accountId = urlParams.get('accountId');
    } else if (window.location.pathname === `${routeCodes.MANAGE_ACCOUNT}${subRouteCodes.MANAGE_ACCOUNT.MANAGE_TOKENS}`) {
      // code param is sent when vetted token google login redirection 
      googleGrantCode = urlParams.get('code');
      isVettedToken = true;
    }

    dispatch(getCurrentUserDetails(accountId))
      .then(async() => {
        if (googleGrantCode) {
          dispatch(createAccessToken(googleGrantCode, isVettedToken));
        }
        await dispatch(fetchContentstackAsync());
      });
    
  }

  setNotificationCenterVisibility = isOpen => {
    const { dispatch } = this.props;
    dispatch(setNotificationCenterModalState(isOpen));
  };

  setGlobalPriceUpdateModalVisibility = (isAfterGlobalPriceUpdate, isOpen) => {
    const { dispatch, user } = this.props;
    dispatch(setGlobalPriceUpdateModalState(isOpen));
    if (!isAfterGlobalPriceUpdate) {
      createEvent(CATEGORIES.GP, ACTIONS.NO_FOR_GENERIC_COST_ROLLUP, `${user.get('opcoId')}-${user.get('syscoCustomerId')}`, user);
    }
  }

  updateGlobalPrice = () => {
    const { dispatch, user } = this.props;
    dispatch(updateGlobalPrice()).then(() => {
      dispatch(getCurrentUserDetails(user.getSyscoId()));
      dispatch(fetchNotificationsAsync());
      this.setNotificationCenterVisibility(true);
    });
    createEvent(CATEGORIES.GP, ACTIONS.INITIATE_GENERIC_COST_ROLLUP, `${user.get('opcoId')}-${user.get('syscoCustomerId')}`, user);
  }

  setPricOutdatedWarning = (type) => {
    const { dispatch } = this.props;
    switch (type) {
      case 'setPriceOutdatedWarningState':
        dispatch(setPriceOutdatedWarningState(false));
        break;
      case 'setAfterPriceOutdatedWarningState':
        dispatch(setAfterPriceOutdatedWarningState(true));
        break;
    }
  }

  render() {
    const {
      notifications: { isNotificationCenterOpen },
      user,
      syscoProducts,
      currentBrand,
      globalPrice: { isModalOpen, isLoading, isPriceOutdatedWarning },
      dispatch,
    } = this.props;
    const priceEffectiveDate = getPriceEffectiveDate(currentBrand);
    const cutOffDate = moment().subtract(6, 'months').startOf('day');
    const priceEffDate = moment.utc(priceEffectiveDate).local();

    return (
      <div className='application'>
        {getRoutes(this.props.store)}
        <NotificationsCenter
          isModalOpen={ isNotificationCenterOpen }
        />
        {
          !!priceEffectiveDate && isGlobalPriceEligible(user, syscoProducts) ? (
            <GlobalPriceModal
              isModalOpen={ isModalOpen }
              changeVisibility={ this.setGlobalPriceUpdateModalVisibility }
              changeNotificationCenterVisibility={ this.setNotificationCenterVisibility }
              updateGlobalPrice={ this.updateGlobalPrice }
              headerString={ GP_PRICE_UPDATE_MODAL_HEADER }
              descriptionString1={ GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION1 }
              descriptionString2={ (priceEffDate.isAfter(cutOffDate)) ? GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION2 : GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION4 }
              descriptionString3={ (priceEffDate.isAfter(cutOffDate)) ? GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION3 : GP_PRICE_UPDATE_MODAL_TEXT_DESCRIPTION5 }
              priceEffectiveDate={ priceEffectiveDate }
              setPricOutdatedWarning= { this.setPricOutdatedWarning }
              isPriceOutdatedWarning= { isPriceOutdatedWarning }
            />
          ) : null
        }
        <PageLoadingWithText
          open={ isLoading }
          text={ 'Updating Menus, Recipes and Ingredients' }
        />
      </div>
    );
  }
}

export default Root;
